import 'what-input';

import { useConfigContext } from 'lib/core/config';
import { useAuthContext } from 'lib/core/context/AuthProvider';

// contexts
import ContactContext from 'lib/common/contexts/ContactContext';
import LogStreamProvider from 'lib/common/contexts/LogStreamContext';
import PermissionsContext from 'lib/common/contexts/PermissionsContext';
import RelatedCallsProvider from 'lib/common/contexts/RelatedCallsContext/Provider';

import Loader from 'lib/common/components/Loader';

// components
import getQueryParam from 'lib/common/utils/getQueryParam';

import LayoutSwitcher from './components/LayoutSwitcher';

const REVERSED_APP_LAYOUT_QUERY_PARAM = 'reversed';

function Routes() {
  const { user } = useAuthContext();
  const { config } = useConfigContext();

  // Define this in here, so we can capture it before any routes changes or any redirects occur
  const isReversedLayout = Boolean(getQueryParam({ param: REVERSED_APP_LAYOUT_QUERY_PARAM }));

  if (!user) {
    return <Loader fixed />;
  }

  return (
    <PermissionsContext user={user} config={config}>
      <LogStreamProvider>
        <RelatedCallsProvider>
          <ContactContext>
            <LayoutSwitcher isReversedLayout={isReversedLayout} user={user} />
          </ContactContext>
        </RelatedCallsProvider>
      </LogStreamProvider>
    </PermissionsContext>
  );
}

export default Routes;
